import { AclMetaData } from "../../course/modals/CourseBasicInfo";
import { RequestContentType } from "./ContentRequestCreate";

export enum RequestPriority {
  IMPORTANT_AND_URGENT = "importantAndUrgent",
  IMPORTANT_BUT_NOT_URGENT = "importantButNotUrgent",
  NOT_IMPORTANT_BUT_URGENT = "notImportantButUrgent",
  NOT_IMPORANT_AND_NOT_URGENT = "notImportantAndNotUrgent",
}

export enum TypeOfAuthor {
  CREATOR = "creator",
  EVALUATOR = "evaluator",
  LANGUAGE_EVALUATOR = "languageEvaluator",
  MODERATOR = "moderator",
  PUBLISHER = "publisher",
}

interface Creator {
  endDate: string;
}

interface Evaluator {
  endDate: string;
}

interface LanguageEvaluator {
  endDate: string;
}

interface Moderator {
  endDate: string;
}

interface Publisher {
  endDate: string;
}

export interface Roles {
  creator?: Creator;
  evaluator?: Evaluator;
  languageEvaluator?: LanguageEvaluator;
  moderator?: Moderator;
  publisher?: Publisher;
}

export interface Client {
  name: string;
  id: string;
  users: { name: string; id: string }[];
}


interface SubjectName {
  id: string;
  name: string;
}

export interface Owners {
  roles?: Roles;
  status: "draft" | "published";
  client: Client;
  type: "subject" | "test-compiler";
  subjects: SubjectName[];
  isEmailTriggered?: boolean;
}

interface CourseTypeName {
  name: string;
  id: string; // _id also in response object, check!
}

interface AssignorName {
  name: string;
  id: string;
}

export interface Author {
  assignedDate: string;
  name: string;
  type: string;
  id: string;
  client: { name: string; id: string };
  isEmailTriggered?: boolean;
}

export interface AuthorFromAPI {
  id: string;
  name: string;
}

export interface SubQuestionsPassage {
  code: number;
  count: number;
  type: string;
}
export interface Question {
  authors: Author[];
  syllabus: { subjects: any[]; secondarySubjects: any[] };
  count: number | string;
  contentRequestItemsId: any;
  passage: SubQuestionsPassage[];
  description: string;
  code: string | number;
  type: string;
  _id?: string;
}
export interface Subject extends SubjectName {
  assignor?: AssignorName;
  progress?: { count: number; total: number };
  questions: Question[];
}

export interface TestDetails {
  contentRequestItemsId: any;
  type?: string;
  name: string;
  assignor?: AssignorName;
  authors: Author[];
  description?: string;
}

export interface RequestInfoDetails {
  subjects: Subject[];
  courseTypes: CourseTypeName[];
  testDetails?: TestDetails;
}

export interface RequestInfo {
  owners: Owners[];
  details: RequestInfoDetails;
  totalCount: number;
  type: RequestContentType;
  endDate: string | Date;
  startDate: string | Date;
  priority?: RequestPriority;
  orderNote?: string;
  orderNoteAttachments?: (string | File)[];
}

export interface ContentRequest {
  _id?: string;
  createdAt?: string;
  requestInfo: RequestInfo;
  publishedOn: any; // Need to check with backend about data type
  status: "draft" | "published";
  completionPercent: Number;
  title: string;
  requestId?: string;
  progress?: Progress; // Need to check with backend about data type
  aclMetaData?: ContentRequestAclMetaData;
  isDeleted?: boolean;
  updatedAt?: string;
}

export interface Progress {
  details: ProgressDetails;
  totalCompleted: number;
  totalCount: number;
}

interface ProgressDetails {
  question: ProgressDetailsQuestion;
  test: ProgressDetailsTest;
}

interface ProgressDetailsQuestion {
  roles: ProgressDetailsQuestionRoles;
  totalCompleted: number;
  totalCount: number;
}

interface ProgressDetailsTest {
  roles: ProgressDetailsTestRoles;
  totalCompleted: number;
  totalCount: number;
}

interface ProgressDetailsQuestionRoles {
  creator: CreatorDetails;
  evaluator: EvaluatorDetails;
  languageEvaluator: LanguageEvaluatorDetails;
  moderator: ModeratorDetails;
  publisher: PublisherDetails;
}

interface ProgressDetailsTestRoles {
  creator: CreatorDetails;
  evaluator: EvaluatorDetails;
  languageEvaluator: LanguageEvaluatorDetails;
  moderator: ModeratorDetails;
  publisher: PublisherDetails;
}

interface CreatorDetails {
  authors: any[];
  totalCompleted: number;
  totalCount: number;
}
interface EvaluatorDetails {
  authors: any[];
  totalCompleted: number;
  totalCount: number;
}
interface LanguageEvaluatorDetails {
  authors: any[];
  totalCompleted: number;
  totalCount: number;
}
interface ModeratorDetails {
  authors: any[];
  totalCompleted: number;
  totalCount: number;
}
interface PublisherDetails {
  authors: any[];
  totalCompleted: number;
  totalCount: number;
}

export interface JobDoneRequest {
  contentRequestId: string;
  role: string;
  contentType: string;
  contentRequestItemId?: string;
  content_id?: string;
}

export interface ContentRequestAclMetaData {
  clientId: string;
  createdBy: { email: string; id: string, firstName: string, lastName: string; };
  updatedBy: { email: string; id: string };
}

export interface TopNav {
  Priority?: string;
  Deadline?: string;
  Goal?: string;
  Subject?: string;
  "Assigned by"?: string;
  RequestOwners?: string;
  Status?: string;
}

export interface HeadingsTopNav {
  icon?: string;
  label: string;
  subLabel: string;
  color?: string;
}

export interface AddFeedBack {
  contentRequestId: string;
  contentId: string;
  comment: string;
  role: string;
  tag: string;
  contentRequestItemId: string;
  contentType: string;
}

export interface ReplyFeedback {
  feedbackId: string;
  contentRequestId: string;
  contentId: string;
  comment: string;
  role: string;
  tag: string;
  contentRequestItemId: string;
  contentType: string;
}

export interface ResolveFeedback {
  feedbackId: string;
  role: string;
  contentRequestItemId: string;
  contentType: string;
}

export interface RequestData {
  requestId: string;
  isUserMultiCenterHead: boolean;
  isUserCenterhead: boolean;
  isUserContentAuthor: boolean;
}
